"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _withStyles = _interopRequireDefault(require("../withStyles"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var Toggle =
/*#__PURE__*/
function (_Component) {
  _inherits(Toggle, _Component);

  function Toggle() {
    _classCallCheck(this, Toggle);

    return _possibleConstructorReturn(this, _getPrototypeOf(Toggle).apply(this, arguments));
  }

  _createClass(Toggle, [{
    key: "render",
    value: function render() {
      var _this = this;

      var _this$props = this.props,
          classes = _this$props.classes,
          className = _this$props.className,
          checkedIcon = _this$props.checkedIcon,
          label = _this$props.label,
          tabIndex = _this$props.tabIndex,
          uncheckedIcon = _this$props.uncheckedIcon,
          validation = _this$props.validation,
          theme = _this$props.theme,
          _this$props$withPaddi = _this$props.withPadding,
          withPadding = _this$props$withPaddi === void 0 ? true : _this$props$withPaddi,
          rest = _objectWithoutProperties(_this$props, ["classes", "className", "checkedIcon", "label", "tabIndex", "uncheckedIcon", "validation", "theme", "withPadding"]);

      return _react.default.createElement("div", {
        className: (0, _classnames.default)(classes.scaffold, className)
      }, _react.default.createElement("label", {
        className: classes.root,
        ref: function ref(l) {
          _this.label = l;
        },
        onKeyDown: function onKeyDown(e) {
          if (e.keyCode === 32) {
            e.preventDefault();

            _this.label.click();
          }
        },
        tabIndex: rest.disabled ? null : tabIndex
      }, _react.default.createElement("input", _extends({
        ref: function ref(c) {
          _this.checkbox = c;
        }
      }, rest, {
        style: {
          display: "none"
        }
      })), _react.default.createElement("span", {
        className: (0, _classnames.default)(classes.toggle, withPadding && classes.withPadding)
      }, rest.checked ? checkedIcon : uncheckedIcon), label && _react.default.createElement("span", {
        className: classes.label
      }, label)), validation ? _react.default.createElement("div", {
        className: classes.validation
      }, validation) : null);
    }
  }]);

  return Toggle;
}(_react.Component);

_defineProperty(Toggle, "defaultProps", {
  tabIndex: "0",
  type: "text"
});

var styles = function styles(theme) {
  return {
    scaffold: {
      position: "relative",
      display: "flex"
    },
    root: {
      display: "inline-flex",
      alignItems: "center",
      "&:focus": {
        outline: "1px dotted ".concat(theme.colors.gray400) // Modify default focus glow

      }
    },
    toggle: {
      position: "relative",
      display: "inline-block",
      width: "20px",
      height: "20px",
      flexShrink: "0",
      overflow: "hidden",
      fill: theme.colors.gray800
    },
    withPadding: {
      width: "36px",
      height: "36px",
      padding: "8px"
    },
    label: {
      fontSize: "16px",
      fontWeight: "500",
      paddingRight: "12px" // extra hitbox padding

    }
  };
};

var _default = (0, _withStyles.default)(styles, {
  name: "EuiToggle"
})(Toggle);

exports.default = _default;